<template>
  <footer id="footer">
    <div id="contact-info">
      <p>Niterói, RJ</p>
      <p>(21) 2629-3887</p>
      <p>contato.samatech@gmail.com</p>
    </div>
    <div class="img-container">
      <img class="logo" width="30" alt="SAMATech" src="../assets/img/logo-min.png" />
    </div>
    <p id="copyright">
      <span>Copyright &copy; 2020 SAMATech</span>
      <span class="sep">|</span>
      <span>
        Desenvolvido por
        <a href="https://toti.site" target="_blank" rel="noopener">Toti</a>
      </span>
    </p>
    <BackToTop></BackToTop>
  </footer>
</template>

<style scoped lang="scss">
footer {
  background: #333;
  color: #999;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  font-size: 1.15rem;
  padding: 2rem 2rem;
  @media screen and (max-width: 700px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 2rem 0;
    & > * {
      padding: 1em 0;
      text-align: center;
    }
  }
  & > * {
    width: 48%;
    box-sizing: border-box;
    max-width: calc(1280px / 2);
    padding: 0 20px;
    @media screen and (max-width: 900px) {
      font-size: 1rem;
    }
    @media screen and (max-width: 700px) {
      padding: 0;
    }
  }
  p {
    margin: 0;
  }
  #contact-info {
    text-align: right;
    @media screen and (max-width: 700px) {
      text-align: center;
      width: auto;
      margin-bottom: 0.5em;
    }
  }
  #copyright {
    margin-top: 2rem;
    padding: 0;
    width: 100%;
    max-width: none;
    text-align: center;
    font-size: 0.9rem;
    .sep {
      display: none;
    }
    span {
      display: block;
    }
  }
  .logo {
    width: 170px;
  }
}
</style>

<script>
import BackToTop from '@/components/geral/BackToTop.vue';

export default {
  components: {
    BackToTop,
  }
}
</script>